<div class="roots-table-card">
  <mat-table
    #sort="matSort"
    matSort
    [dataSource]="dataSource"
    >
    @for (actionCol of actionCols; track actionCol; let i = $index) {
      <ng-container
        matColumnDef="{{ actionCol.name }}"
        >
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ actionCol.name | columnLabel }}
        </mat-header-cell>
        <mat-cell *matCellDef="let entity; let e = index">
          @if (actionCol.icon) {
            <!-- If there is a switch present, put its switch values here base on prop name-->
            @if (actionCol.switch) {
              @if (entity[actionCol.switch[0].PROP_name]) {
                <ng-container class="center">
                  <button
                    mat-raised-button
                    color="primary"
                    (click)="switchClicked(actionCol.switch[0], entity)"
                    matTooltip="{{actionCol.switch[0].toolTip}}"
                    >
                    {{actionCol.switch[0].name}}
                  </button>
                </ng-container>
              } @else {
                <button
                  mat-raised-button
                  color="warn"
                  (click)="switchClicked(actionCol.switch[1], entity)"
                  matTooltip="{{actionCol.switch[1].toolTip}}"
                  >
                  {{actionCol.switch[1].name}}
                </button>
              }
            } @else {
              <button
                mat-icon-button
                color="primary"
                (click)="actionClicked(entity, actionCol)"
                matTooltip="{{actionCol.toolTip}}"
                matTooltipPosition="above"
                >
                <mat-icon class="mat-18">{{actionCol.icon}}</mat-icon>
              </button>
            }
          } @else {
            @if (actionCol.textButton === true) {
              <button mat-button
                color="primary"
                (click)="actionClicked(entity, actionCol)"
                matTooltip="{{actionCol.toolTip}}"
                matTooltipPosition="above">
                {{ entity[actionCol.name] }}
              </button>
            } @else {
              {{ entity[actionCol.name] }}
            }
            <!-- {{ entity[actionCol.name] }} -->
          }
        </mat-cell>
      </ng-container>
    }

    <mat-header-row *matHeaderRowDef="actionNameList"></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: actionNameList"
      matRipple
      class="example-element-row"
      (click)="addDataToCustomDataSet(row)"
      >
    </mat-row>
  </mat-table>

  <div class="roots-table-footer">
    <mat-paginator #paginator [pageSize]="20" [pageSizeOptions]="[5, 10, 20, 50, 100]" showFirstLastButtons>
    </mat-paginator>
  </div>
</div>